import React from 'react'
import PropTypes from 'prop-types'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from 'actions'
import Button, { TYPES } from 'components/Button'
import _partial from 'lodash/partial'
import { List } from 'immutable'
import { getBrowserLanguage } from 'browser/language'

import strings from './strings.json'

function _onClick (props) {
  const langs = List([getBrowserLanguage()])
  const {
    auth,
    setUserDataLanguage,
    setAlertBarVisible,
    setAlertBarDismissed,
    setUserDataLanguageAlertBarAccepted,
  } = props
  setUserDataLanguage(langs)
  setUserDataLanguageAlertBarAccepted(auth, true)
  setAlertBarVisible(false)
  setAlertBarDismissed(true)
}

function AlertBarAnonymousLanguage (props) {
  const _partialOnClick = _partial(_onClick, props)
  const language = getBrowserLanguage()

  return (
    <div className="alert-bar--anonymous-language">
      <Button
        type={TYPES.LINK}
        onClick={_partialOnClick}
        className="alert-bar--anonymous-language-action"
      >
        {strings.message[language]}
      </Button>
    </div>
  )
}

AlertBarAnonymousLanguage.propTypes = {
  setUserDataLanguage: PropTypes.func.isRequired,
  setAlertBarVisible: PropTypes.func.isRequired,
  setUserDataLanguageAlertBarAccepted: PropTypes.func.isRequired,
  setAlertBarDismissed: PropTypes.func.isRequired,
}

export default connectRedux(
  (state) => ({
    auth: state.auth,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setUserDataLanguage: actions.user.setUserDataLanguage,
      setAlertBarVisible: actions.alertBar.setAlertBarVisible,
      setUserDataLanguageAlertBarAccepted: actions.user.setUserDataLanguageAlertBarAccepted,
      setAlertBarDismissed: actions.alertBar.setAlertBarDismissed,
    }
  },
)(AlertBarAnonymousLanguage)
